import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../_services/auth-service.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ReactiveFormsModule],
})
export class RegisterComponent implements OnInit {
  form: UntypedFormGroup;
  clicked = false;
  showPassword = false;
  statusText = '';
  statusClass = '';
  familyCode = '';
  codeCopied = false;

  constructor(private authService: AuthService, private cdr: ChangeDetectorRef, private router: Router) {}

  ngOnInit(): void {
    this.form = new UntypedFormGroup({
      subscription: new UntypedFormControl('', [Validators.required]),
      description:  new UntypedFormControl(''),
      username:     new UntypedFormControl('', [Validators.required]),
      email:        new UntypedFormControl('', [Validators.required, Validators.email]),
      password:     new UntypedFormControl('', [Validators.required]),
    });
  }

  submit(): void {
    this.clicked = true;
    this.authService.register(this.form.value).subscribe({
      next: (response) => {
        const result = JSON.parse(response);
        this.familyCode  = result.familyCode ?? '';
        this.statusClass = 'status-success';
        this.statusText  = result.result ?? 'Aanmelding geslaagd!';
        this.cdr.markForCheck();
      },
      error: () => {
        this.statusClass = 'status-error';
        this.statusText  = 'Er is een fout opgetreden. Probeer opnieuw.';
        this.clicked = false;
        this.cdr.markForCheck();
      },
    });
  }

  copyCode(): void {
    navigator.clipboard.writeText(this.familyCode).then(() => {
      this.codeCopied = true;
      this.cdr.markForCheck();
      setTimeout(() => { this.codeCopied = false; this.cdr.markForCheck(); }, 2000);
    });
  }

  goToLogin(): void {
    this.router.navigate(['/family']);
  }
}
